import React from 'react'
import NavBar from './Components/NavBar';
import Hero from './Components/Hero';
import Hero2 from './Components/Hero2';
import About from './Components/About';
import Theme from './Components/Theme';
import Theme2 from './Components/Theme2';
import Aos from "aos";
import { useEffect } from "react";
import Contact from './Components/Contact';
import Reviews from './Components/Reviews';
import Footer from './Components/Footer';

function App() {
  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <>
      <NavBar></NavBar>
      <Hero></Hero>
      <Hero2></Hero2>
      <About></About>
      <Theme></Theme>
      <Theme2></Theme2>
      <Reviews></Reviews>
      <Contact></Contact>
      <Footer></Footer>
    </>
  );
}

export default App;
